module.exports = __webpack_public_path__ + "static/media/shopping-basket.dd6967b1.svg";